if (!customElements.get('mg-bulk-buy')) {
  class MeglioBulkBuy extends HTMLElement {
    connectedCallback() {
      this.form = document.getElementById(this.dataset.form);
      this.native = this.form?.querySelector('[name="add"]');
      this.quantity = this.form?.querySelector('[name="quantity"]');
      if (!this.native || !this.quantity) return;
      this.section = this.closest('.cc-main-product');
      this.source = this.querySelector('[data-bulk-source]');
      this.panel = this.querySelector('.mg-bulk-buy-panel');
      this.body = this.querySelector('tbody');
      this.status = this.querySelector('.mg-bulk-status');
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.body.addEventListener('click', (event) => {
        const button = event.target.closest('button[data-quantity]');
        if (button) this.add(button);
      }, options);
      this.section.addEventListener('on:cart:add', () => this.finish(true), options);
      this.section.addEventListener('on:line-item:change', () => this.finish(true), options);
      this.section.addEventListener('on:cart:error', (event) => this.finish(false, event.detail?.error), options);
      this.section.addEventListener('on:variant:change', () => {
        this.status.textContent = '';
        this.sync();
      }, options);
      this.sourceObserver = new MutationObserver(() => this.render());
      this.sourceObserver.observe(this.source, { childList: true, subtree: true, characterData: true });
      this.buttonObserver = new MutationObserver(() => this.sync());
      this.buttonObserver.observe(this.native, { attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'class'] });
      this.render();
    }
    render() {
      const table = this.source.querySelector('.docapp-volume-discounts-promo-table');
      const headers = table?.querySelectorAll('.docapp-volume-discounts-promo-table-header');
      const cells = Array.from(table?.querySelectorAll('.docapp-volume-discounts-promo-table-item') || []);
      const rows = [];
      if (headers?.length === 2 && cells.length > 0 && cells.length % 2 === 0) {
        for (let i = 0; i < cells.length; i += 2) {
          const match = cells[i].textContent.trim().match(/^(\d+)(?:\s.*)?$/);
          const quantity = Number(match?.[1]);
          const price = cells[i + 1].querySelector('b,strong')?.textContent.trim();
          if (!Number.isSafeInteger(quantity) || quantity < 1 || !price) { rows.length = 0; break; }
          const saving = cells[i + 1].textContent.trim().replace(price, '').trim();
          rows.push({ quantity, price, saving, label: cells[i].textContent.trim() });
        }
      }
      this.panel.hidden = !rows.length;
      this.source.hidden = !!rows.length;
      if (!rows.length) return;
      const signature = JSON.stringify(rows);
      if (signature === this.signature) { this.sync(); return; }
      this.signature = signature;
      const fragment = document.createDocumentFragment();
      rows.forEach((row) => {
        const tr = document.createElement('tr');
        const quantity = document.createElement('th'); quantity.scope = 'row';
        const count = document.createElement('strong'); count.textContent = row.label;
        quantity.append(count);
        const cell = document.createElement('td');
        const price = document.createElement('strong');
        const taxMatch = row.price.match(/^(.*?)\s*(\([^)]*\))$/);
        price.textContent = taxMatch ? taxMatch[1] : row.price;
        const tax = document.createElement('span'); tax.className = 'mg-bulk-tax'; tax.textContent = taxMatch ? taxMatch[2] : '';
        if (!taxMatch) tax.hidden = true;
        const saving = document.createElement('span'); saving.className = 'mg-bulk-saving'; saving.textContent = row.saving;
        quantity.append(saving);
        cell.append(price, tax);
        const action = document.createElement('td');
        const button = document.createElement('button'); button.type = 'button'; button.dataset.quantity = row.quantity;
        button.className = 'mg-bulk-button';
        button.setAttribute('aria-label', this.dataset.label.replace('[quantity]', row.quantity));
        action.append(button); tr.append(quantity, cell, action); fragment.append(tr);
      });
      this.body.replaceChildren(fragment);
      this.sync();
    }
    nativeBusy() {
      return this.native.getAttribute('aria-disabled') === 'true' || this.native.classList.contains('is-loading');
    }
    sync() {
      this.body.querySelectorAll('button').forEach((button) => {
        button.disabled = !!this.pending || this.native.disabled || this.nativeBusy();
        button.textContent = this.pending === Number(button.dataset.quantity) ? this.dataset.adding : this.native.disabled ? this.dataset.unavailable : this.dataset.add.replace('[quantity]', button.dataset.quantity);
      });
    }
    add(button) {
      if (button.disabled || this.pending || this.native.disabled || this.nativeBusy()) return;
      const quantity = Number(button.dataset.quantity);
      const variant = this.form.querySelector('[name="id"]');
      if (!variant?.value || variant.disabled || !Number.isSafeInteger(quantity) || quantity < 1) return;
      this.quantity.value = String(quantity);
      this.quantity.dispatchEvent(new Event('change', { bubbles: true }));
      if (!this.form.reportValidity()) return;
      this.pending = quantity;
      this.status.textContent = '';
      this.sync();
      this.native.click();
      queueMicrotask(() => {
        if (this.pending && !this.nativeBusy()) this.finish(false);
      });
    }
    finish(success, error) {
      if (!this.pending) return;
      this.status.textContent = success ? this.dataset.added.replace('[quantity]', this.pending) : error || this.dataset.error;
      this.pending = null;
      this.sync();
    }
    disconnectedCallback() {
      this.events?.abort();
      this.sourceObserver?.disconnect();
      this.buttonObserver?.disconnect();
    }
  }
  customElements.define('mg-bulk-buy', MeglioBulkBuy);
}
